import _ from 'lodash'
import { Controller, useForm } from 'react-hook-form'
import moment from 'moment'

import api from '../../../services/api'
import useModal from '../../../hooks/useModal'

import * as S from '../Modal.styles'
import { BasicTextFieldForForm } from '../../InputBoxes'
import { CompleteBtn } from '../../Buttons'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'

import { ReactComponent as CloseIcon } from '../../../assets/images/close_delete_icon.svg'

export default function UpdateSessionalPlanModal(props) {
  const { control, handleSubmit } = useForm()
  const { closeModal, openModal } = useModal()

  async function addSessionalPlan({ sessionName, sessionStartOn, sessionEndOn }) {
    api.post('/sessional-plans', {
      sessionName,
      sessionEndOn: moment(sessionEndOn).format('YYYY-MM-DD'),
      sessionStartOn: moment(sessionStartOn).format('YYYY-MM-DD'),
    }).then(result => {
      const { sessionalPlanList } = result.data
      props.setSessionalPlanList(sessionalPlanList)
      props.setCurrentSessinalPlanId(_.head(sessionalPlanList).sessionalPlanId)
      closeModal()
    })
    .catch(e => {
      console.error(e)
      openModal({ type: 'alert', props: { isError: true, contents: e.response?.data.message || e.message }})
    })
  }

  async function modifySessionalPlan({ sessionName, sessionStartOn, sessionEndOn }) {
    api.put(`/sessional-plans/${props.sessionalPlanId}`, {
      sessionName,
      sessionEndOn: moment(sessionEndOn).format('YYYY-MM-DD'),
      sessionStartOn: moment(sessionStartOn).format('YYYY-MM-DD'),
    }).then(result => {
      const { sessionalPlanList } = result.data
      props.setSessionalPlanList(sessionalPlanList)
      props.setCurrentSessinalPlanId(_.head(sessionalPlanList).sessionalPlanId)
      closeModal()
    })
    .catch(e => {
      console.error(e)
      openModal({ type: 'alert', props: { isError: true, contents: e.response?.data.message || e.message }})
    })
  }

  return (
    <>
      <S.Background />
      <S.ModalBox height='300px' width='350px'>
        <CloseIcon
          className='close-icon'
          width='25px'
          onClick={closeModal}
        />
        <S.ModalContents width='80%' height='80%'>
          <S.Title>{props.sessionalPlanId ? '세셔널 플랜 수정' : '세셔널 플랜 추가'}</S.Title>
          <BasicTextFieldForForm
            control={control}
            defaultValue={props?.sessionalPlan?.sessionalPlanInfo.sessionName || null}
            label='세셔널 플랜 명'
            name='sessionName'
            minWidth='100%'
            rules={{ required: '세셔널 플랜 이름을 입력해 주세요' }}
          />
          <S.FlexContainer>
            <Controller
              control={control}
              defaultValue={
                props?.sessionalPlan?.sessionalPlanInfo.sessionStartOn
                  ? moment(props?.sessionalPlan?.sessionalPlanInfo.sessionStartOn)
                  : moment()}
              name='sessionStartOn'
              render={({ field}) => (
                <LocalizationProvider dateAdapter={AdapterMoment}>
                  <DatePicker
                    defaultValue={
                      props?.sessionalPlan?.sessionalPlanInfo.sessionStartOn
                      ? moment(props?.sessionalPlan?.sessionalPlanInfo.sessionStartOn)
                      : moment()}
                    format='YY-MM-DD'
                    inputRef={field.ref}
                    label='세션 시작 날짜'
                    onChange={field.onChange}
                    slotProps={{ textField: { size: 'small' }}}
                    sx={{ width: '50%' }}
                  />
                </LocalizationProvider>
              )}
            />
            <S.Sign>~</S.Sign>
            <Controller
              control={control}
              defaultValue={
                props?.sessionalPlan?.sessionalPlanInfo.sessionEndOn
                  ? moment(props?.sessionalPlan?.sessionalPlanInfo.sessionEndOn)
                  : moment().add(1, 'month')}
              name='sessionEndOn'
              render={({ field}) => (
                <LocalizationProvider dateAdapter={AdapterMoment} >
                  <DatePicker
                    defaultValue={
                      props?.sessionalPlan?.sessionalPlanInfo.sessionEndOn
                        ? moment(props?.sessionalPlan?.sessionalPlanInfo.sessionEndOn)
                        : moment().add(1, 'month')}
                    format='YY-MM-DD'
                    inputRef={field.ref}
                    label='세션 종료 날짜'
                    onChange={field.onChange}
                    slotProps={{ textField: { size: 'small' }}}
                    sx={{ width: '50%' }}
                  />
                </LocalizationProvider>
              )}
            />
          </S.FlexContainer>
          <S.BtnContainer>
            <CompleteBtn
              fontSize='1em'
              height='40px'
              width='100%'
              onClick={handleSubmit(props.sessionalPlanId ? modifySessionalPlan : addSessionalPlan)}
            >확인
            </CompleteBtn>
          </S.BtnContainer>
        </S.ModalContents>
      </S.ModalBox>
    </>
  )
}